import * as React from 'react'
import { IRiderObject, IStateMetadata } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import RiderBottomBar from '../CreateRiderBottomBar'
import WalletPaneForm from '../../common/WalletPaneForm'

interface IWalletPaneProps {
  metadata: IStateMetadata
  rider: IRiderObject
  currentStep: number
  onCompleteStep: (step: number) => void
  addRiderPaymentSource: (paymentSource: any, riderId: string) => Promise<any>
  updateDefaultPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
  removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => Promise<any>
}

class WalletPane extends React.Component<IWalletPaneProps> {
  constructor(props: any) {
    super(props)
    this.props.onCompleteStep(this.props.currentStep)
  }

  public render() {
    const isSaving = this.props.metadata.fetching
    return (
      <WalletPaneForm {...this.props}>
        <RiderBottomBar
          isSaved={!this.props.metadata.fetching}
          isSaving={isSaving}
          finishPath={'/riders'}
          nextStepPath={'/riders/create/wallet'}
          previousStepPath={'/riders/create/membership'}
          skipStepPath={'/riders/create/wallet'}
        />
      </WalletPaneForm>
    )
  }
}

export default WalletPane



// WEBPACK FOOTER //
// ./src/components/riders/createrider/wallet/WalletPane.tsx